<!-- <li class="panel"> -->
<ng-template [ngIf]="entity">
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(entity)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
    <h4 class="titolo col-sm-3">
      {{entity.patologia}}
    </h4>
	</div>
</div>
</ng-template>
<!-- </li> -->
